import { WatchlistAction, StorefrontItem, EnrichmentRequest } from 'DVWebNodeUtils'
import { CommonPlaybackAction } from './Hover/Headline/PlaybackBlock'

export const createPlaybackAction = (enrichment: StorefrontItem): CommonPlaybackAction | undefined => {
    if (!enrichment)
        return undefined
    if (enrichment && !enrichment.playbackAction)
        return undefined
    const newProgress = enrichment.progress && enrichment.progress.percentage;
    const newPlaybackAction = enrichment.playbackAction;
    const merged = {
        ...newPlaybackAction,
        progress: newProgress
    }
    return merged
};
export const extractTitleIDTypeFromWatchlistAction = (watchlistAction?: WatchlistAction) => {
    const valueInWatchlist = watchlistAction && watchlistAction.endpoint &&
        watchlistAction.endpoint.query && watchlistAction.endpoint.query.titleType;
    if (valueInWatchlist) {
        const asLower = valueInWatchlist.toLowerCase();
        if (asLower == "season")
            return "SEASON";
        if (asLower == "event")
            return "LIVEEVENT"
    }
    return "UNKNOWN"
};
export const extractTitleIdFromWatchlistAction = (watchlistAction?: WatchlistAction) => {
    return watchlistAction &&
        watchlistAction.endpoint &&
        watchlistAction.endpoint.query &&
        watchlistAction.endpoint.query.titleID
}

export const stringifyEnrichmentsOnClient = (enrichment?: EnrichmentRequest[] | undefined): EnrichmentRequest[] | string | undefined => (
    global.__SERVER__ === true ? enrichment : enrichment && JSON.stringify(enrichment)
)